import getLocalString from "constants/Localization";
import {
  GetOrganizationEmailIdentityDocument,
  useSaveOrganizationEmailIdentityMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useSaveOrganizationEmailIdentity() {
  const [mutation, { data, loading, error }] = useSaveOrganizationEmailIdentityMutation({
    refetchQueries: [{ query: GetOrganizationEmailIdentityDocument }],
  });

  return useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "saveOrganizationEmailIdentity",
    },
    {
      successMessage: getLocalString("emailIdentity.save-success"),
      failureMessage: getLocalString("emailIdentity.save-failure"),
    }
  );
}
